import { inject } from 'aurelia-framework';
import { EnvironmentService } from '../../services/environmentService';
import {UserMessageService} from '../../services/userMessageService';


@inject(EnvironmentService,UserMessageService)
export class Unsupported {
    constructor(envService,userMessageService) {
        this.envService = envService;
        this.userMessageService = userMessageService;
        this.logo_img = "images/magnfi-logo-small.png";
        this.app_name = "Magnfi";
        this.home_url = window.home_url;
        this.site_url = window.site_url;
        this.supportEmail = window.support_email;
        if(window.whitelabel) {
          this.whitelabel = window.whitelabel;
          this.logo_img = "api/whitelabel/getFile?file=site_logo";
          this.app_name = window.app_name;
          this.safariCheck = false;
        }

        this.browserName = this.envService.browserDetails();
        this.browserAppVersion = navigator.appVersion;
        this.emailCheck = false;

         if(this.browserName.name == "Safari" && !this.envService.isMobile()) {
           this.versionBrowser = this.browserAppVersion.split("Version/")[1];

           this.version = this.versionBrowser.split(/[\s.]+/);
           console.log("browser detail", navigator,"..", this.version[0]);

           if(this.browserName.name=="Safari") {
             this.safariCheck = true;

           }
         }

    }

    activate(model) {

        this.googleChromeDisplay = "Google Chrome";

        if(model.url) {
          console.log("URL =====================>", model.url, window.location.href);
          if(window.location.href.includes('_host_Info')){
            let path = window.location.href.split("?url=");
            this.url = window.location.hostname + "/#/capture/" + path[1];
          }else{
            this.url = window.location.hostname + "/#/capture/" + model.url;
          }
            console.log("url",window,"..", this.url);
            this.isAndroid = this.envService.isAndroid();

            if (this.isAndroid) {

                this.googleChromeLink = "googlechrome://navigate?url=" + this.url;

                this.googleChromeDisplay = "<a href='" + this.googleChromeLink + "'>Google Chrome</a>";
            }

        }

        if(this.browserName.name == "Safari" && !this.envService.isMobile()) {
          this.versionBrowser = this.browserAppVersion.split("Version/")[1];

          this.version = this.versionBrowser.split(/[\s.]+/);
          console.log("browser detail", navigator,"..", this.version[0]);

          if(this.url.includes("email")) {
            this.emailCheck = true;
          }

          if(this.browserName.name=="Safari") {
            this.safariCheck = true;

          }
        }


    }

    copyUrl() {
        this.copyTextToClipboard(this.url);
        this.userMessageService.setUserMessage("user","Copied!");
        this.selectText(this.urlEl);
    }

    copyTextToClipboard(text) {
        if (!navigator.clipboard) {
          this.fallbackCopyTextToClipboard(text);
          return;
        }
        navigator.clipboard.writeText(text).then(function() {
          console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
          console.error('Async: Could not copy text: ', err);
        });
      }

      fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'successful' : 'unsuccessful';
          console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
      }




 selectText(node) {


    if (document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(node);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(node);
        selection.removeAllRanges();
        selection.addRange(range);
    } else {
        console.warn("Could not select text in node: Unsupported browser.");
    }
}

}
